import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "lab" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Calendar Lab", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "Today", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", null, "Add new", -1)

import { onMounted, reactive } from 'vue'
import { context_workspace } from '@/_dev/config'
import { Sunrise } from '@/logic/_infra/time';
import EventsComponent from '@/components/Workspaces/EventsComponent.vue'
import { MeetingRmodel } from '@/app.context/workspace/Event'
import { WorkspaceRmodel } from '@/app.context/workspace.rmodel'
import { Guid } from '@/lib';
import { PersonRmodel } from '@/app.context/workspace/person.rmodel';
import { GroupRmodel } from '@/app.context/workspace/persons.set/group.rmodel';
import AppContext from '@/context';
import { IFileStorage, ITicketStorage, IUserStorage, IWorkspaceStorage } from "@/io/storages";
import AppointmentCreator from '@/components/Workspaces/_spec/AppointmentCreator.vue';
import { Appointment } from '@/logic/workspaces/appointment';
import sys from '@/sys';


export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarLabComponent',
  setup(__props) {

console.log('/lab/Calendar')
const date = new Date('2023-06-22') //temporary date - THU

const eventws_models: MeetingRmodel[] = reactive([])
const eventws_models_today: MeetingRmodel[] = reactive([])


const model: 
{
    context: AppContext | null
    workspace: WorkspaceRmodel | null
    storage: IWorkspaceStorage | null


} = reactive({ workspace: null , context: null, storage: null})

const request: {

    time_text: string,
    datetime: Date
    persons: Set<PersonRmodel>
    groups: Set<GroupRmodel>

    days: { mon1: boolean, tue2: boolean, wed3: boolean, thr4: boolean, fri5: boolean, sat6: boolean, sun7: boolean },
    monthly: { W1: boolean, W2: boolean, W3: boolean, W4: boolean, last: boolean },
    yearly: { M01: boolean, M02: boolean, M03: boolean, M04: boolean, M05: boolean, M06: boolean, M07: boolean, M08: boolean, M09: boolean, M10: boolean, M11: boolean, M12: boolean },
    

} =
    reactive({
        time_text : '',
        datetime: new Date(),
        days: { mon1: false, tue2: false, wed3: false, thr4: false, fri5: false, sat6: false, sun7: false },
        monthly: { W1: false, W2: false, W3: false, W4: false, last: false },
        yearly: { M01: false, M02: false, M03: false, M04: false, M05: false, M06: false, M07: false, M08: false, M09: false, M10: false, M11: false, M12: false },
        persons: new Set<PersonRmodel>(),
        groups: new Set<GroupRmodel>()

    })

function test() {

    

    console.log(appointment())

    model.storage!.appointmentCreate(model.workspace!.wid, appointment())
    
}

function appointment(){


    //const x : { persons:Guid[], groups:Guid[], weekdays:number[], monthly:number[], yearly:number[]} = { persons:[], groups:[], weekdays:[], monthly:[], yearly:[]}

    const x: Appointment = new Appointment()

    x.datetime = request.datetime
    x.uid = Guid.newGuid()

    

    const utcDate = request.datetime.getUTCDate()

    console.log(`utdDate:${utcDate}`)
    console.log(`localDate:${request.datetime.getDate()}`)

    let c = 0 //'correction'
    
    if (utcDate < request.datetime.getDate() ) c = -1;
    if (utcDate > request.datetime.getDate() ) c = +1;

    if (request.days.mon1) x.weekdays.push( c == 0 ? 1 : (c > 0 ? 2 : 7))

    if (request.days.tue2) x.weekdays.push(2 + c)
    if (request.days.wed3) x.weekdays.push(3 + c)
    if (request.days.thr4) x.weekdays.push(4 + c)
    if (request.days.fri5) x.weekdays.push(5 + c)
    if (request.days.sat6) x.weekdays.push(6 + c)

    if (request.days.sun7) x.weekdays.push(c == 0 ? 7 : (c > 0 ? 1 : 6))

    if (request.monthly.W1) x.monthly.push(1)
    if (request.monthly.W2) x.monthly.push(2)
    if (request.monthly.W3) x.monthly.push(3)
    if (request.monthly.W4) x.monthly.push(4)
    if (request.monthly.last) x.monthly.push(-1)


    if (request.yearly.M01) x.yearly.push(1)
    if (request.yearly.M02) x.yearly.push(2)
    if (request.yearly.M03) x.yearly.push(3)
    if (request.yearly.M04) x.yearly.push(4)
    if (request.yearly.M05) x.yearly.push(5)
    if (request.yearly.M06) x.yearly.push(6)
    if (request.yearly.M07) x.yearly.push(7)
    if (request.yearly.M08) x.yearly.push(8)
    if (request.yearly.M09) x.yearly.push(9)
    if (request.yearly.M10) x.yearly.push(10)
    if (request.yearly.M11) x.yearly.push(11)
    if (request.yearly.M12) x.yearly.push(12)
    

    request.persons.forEach(p=>x.persons.push(p.nid))
    request.groups.forEach(g=>x.groups.push(g.uid))


    //if (wee)

    return x

}




onMounted(setup)

//setup()

async function setup(): Promise<void> {

    const context = await context_workspace()

    const workspace = context.cursor.workspace;

    const sunrise = Sunrise.DateAsSunrise(date)

    model.workspace = workspace
    model.context = context

    

    if (workspace != null) {

        const wid = workspace.wid

        model.storage = context.service.workspaceStorage(wid)

        console.log(`Workspace:${wid}`)

        workspace!.meetings.forEach(e => eventws_models_today.push(e))

        const eventws_dto = await context.service.workspaceEvents(wid, sunrise)

        eventws_dto.forEach(e => {

            //const event_model = workspace.eventwSetup(e)

            //eventws_models.push(event_model)
        })

    } else sys.warn("No workspace")
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("h2", null, _toDisplayString(_unref(date)), 1),
    _createVNode(EventsComponent, { events: eventws_models }, null, 8, ["events"]),
    _hoisted_3,
    _hoisted_4,
    _createVNode(EventsComponent, { events: eventws_models_today }, null, 8, ["events"]),
    _hoisted_5,
    _createTextVNode(" - "),
    (model.workspace != null)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_6,
          _createVNode(AppointmentCreator, {
            workspace: model.workspace,
            storage: model.storage,
            date: new Date()
          }, null, 8, ["workspace", "storage", "date"])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})